import { render, staticRenderFns } from "./wheelPage.vue?vue&type=template&id=0ecf3b28&"
import script from "./wheelPage.vue?vue&type=script&lang=js&"
export * from "./wheelPage.vue?vue&type=script&lang=js&"
import style0 from "./wheelPage.vue?vue&type=style&index=0&id=0ecf3b28&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecf3b28')) {
      api.createRecord('0ecf3b28', component.options)
    } else {
      api.reload('0ecf3b28', component.options)
    }
    module.hot.accept("./wheelPage.vue?vue&type=template&id=0ecf3b28&", function () {
      api.rerender('0ecf3b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/pages/wheelPage.vue"
export default component.exports